import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Array.prototype.findIndex';
import 'mdn-polyfills/Array.prototype.includes';
import 'mdn-polyfills/Array.prototype.forEach';
import 'mdn-polyfills/String.prototype.includes';
import 'mdn-polyfills/Array.prototype.some';
import 'mdn-polyfills/Object.assign';
import 'mdn-polyfills/Object.create';
import 'mdn-polyfills/Array.from';
import 'intersection-observer';


// WEBPACK FOOTER //
// ./src/index.js